import { Tag as AntdTag } from "antd";
import styled from "styled-components/macro";

const Tag = styled(AntdTag)`
  margin: 0 !important;
  background-color: ${({ theme }) => theme["@primary"]} !important;
  color: ${({ theme }) => theme["@light"]} !important;
  border: 1px solid ${({ theme }) => theme["@primary-lighter"]} !important;
  cursor: inherit !important;
`;

export default Tag;
